module.exports = __webpack_public_path__ + "img/login.0ea37257.jpg";